<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title">School Uniform</h4>
                    <div class="card-body text-justify">
                        <!-- <p class="lead text-justify inner-lead"><i>The school fully reserves the right of admission and its decision in the matter is final and binding and cannot be questioned.
                            </i></p> -->
                       <div class="row text-center">
                           <div class="col-12">
                            <a  href="/assets/img/admission/uniform/1.jpg" data-lightbox="uniform"> <img src="/assets/img/admission/uniform/1.jpg" alt="Ground" class="img-fluid rounded"></a>
                            </div>
                       </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>